export const PENDO_MAPPINGS = {
  sieLegacyLink: 'FinPro|Exams|Actions|SIE Legacy Link',
  finraLegacyLink: 'FinPro|Exams|Actions|FINRA Legacy Link',
  nasaaLegacyLink: 'FinPro|Exams|Actions|NASAA Legacy Link',
  nfaLegacyLink: 'FinPro|Exams|Actions|NFA Legacy Link',
  msrbLegacyLink: 'FinPro|Exams|Actions|MSRB Legacy Link',
  ceLegacyLink: 'FinPro|Exams|Actions|CE Legacy Link',
  vouchersLegacyLink: 'FinPro|Vouchers|Actions|Vouchers Legacy Link',
};
